<template>
  <label class="relative bg-light-200 dark:bg-dark-800 rounded-md text-light-950 dark:text-dark-50 min-h-14 pl-3 flex flex-col justify-center">
    <div class="font-medium text-2xs leading-tight text-light-600 dark:text-dark-400 absolute top-2.5 pointer-events-none left-3">
      {{ label }}
    </div>

    <select
      :id="id ? id : undefined"
      :required="isRequired"
      class="!outline-none w-full pt-4 border-none font-medium appearance-none cursor-pointer pr-10 !bg-transparent"
      :class="[ isLocked ? 'pointer-events-none' : 'none']"
      v-model="modelValue"
    >
      <option v-if="placeholder" value="" disabled selected hidden>
        {{ placeholder }}
      </option>
      <option
        class="p-4"
        v-for="option in options"
        :value="option.value"
        :key="option.value"
        :disabled="option.isDisabled"
      >
        {{ option.label }}
      </option>
    </select>

    <div 
      class="bg-gradient-to-l from-light-200 to-light-200/0 dark:from-dark-800 dark:to-dark-800/0 absolute top-0 h-full w-6 right-8 pointer-events-none rounded-r-md"
    />

    <IconBase
      :name="isLocked ? 'cute/lock-fill' : 'cute/angle-right'"
      :width:="18"
      class="absolute top-1/2 -translate-y-1/2 right-3"
      :class="[ isLocked ? '' : 'pointer-events-none opacity-50' ]"
      @click="() => isLocked ? router.push({ query: { ...(route.query ?? {}), subscribe: 'true' }}) : true"
    />
  </label>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  id?: string
  isRequired?: boolean
  isLocked?: boolean
  placeholder?: string
  options: {
    label: string
    value: string | number
    isDisabled?: boolean
  }[]
  label?: string
}>(), {
  id: '',
  placeholder: '',
  isRequired: false,
  isLocked: false,
  label: '',
  options: () => [],
})

const modelValue = defineModel<string | number>({
  default: ''
})

const router = useRouter()
const route = useRoute()
</script>